import React, { FunctionComponent } from 'react';
import styles from './ColoredCircle.module.scss';

export interface ColoredCircleProps  { 
    color: 'green' | 'purple' | 'blue' | 'orange' | 'gray';
    value: string;
    size?: 'xs' | 'small' | 'large';
    opaque?: boolean;
    onClick?: () => void;
    ariaLabel?: string;
}

export const ColoredCircle: FunctionComponent<ColoredCircleProps> = ({color, size, opaque, value, onClick, ariaLabel}) => {
    const clickable = onClick ? true : false;
    let getColor = () => {
        switch (color) {
            case 'green':
                return styles.green;
            case 'purple':
                return styles.purple
            case 'blue':
                return styles.blue;
            case 'orange':
                return styles.orange;
            case 'gray':
                return styles.gray;
        }
    }

    let getSize = () => {
        switch (size) {
            case 'xs':
                return styles.coloredCircleExtraSmall;
            case 'small':
                return styles.coloredCircleSmall;
            case 'large':
                return styles.coloredCircleLarge
            default:
                return ''
        }
    }

    const classNames = `${styles.circle} ${clickable ? styles.clickable : ''} ${!opaque ? styles.blur : styles.opaque} ${getSize()} ${getColor()}`;

    if (clickable) {
        return (
            <button
                type="button"
                className={classNames}
                onClick={onClick}
                aria-label={ariaLabel || `Select ${value}`}
            >
                <span>{value}</span>
            </button>
        );
    }

    return (
        <div className={classNames}>
            <span>{value}</span>
        </div>
    );
}

ColoredCircle.defaultProps = {
    size: 'small',
    opaque: false
};